import * as Helper from "./reset_action";

import { LOGIN_USER } from "../../constant/reducer_names";
import { combineReducers } from "redux";

const combinedReducers = combineReducers({
  dashboardReducer:Helper.DashboardReducerWrapper,
  contactReducer:Helper.ContactReducerWrapper,
});

const rootReducer = (state: any, action: any) => {
  if (action.type === `${LOGIN_USER}/logout`) state = undefined;
  return combinedReducers(state, action);
};

export const resetAll = () => ({ type: `${LOGIN_USER}/logout` });
export default rootReducer;